/**
 * Boreal SEO Link Auto-Transformer
 * Automatically converts <a> links to <boreal-seo-link> for specific patterns
 */

class BorealSeoLinkAuto {
  constructor() {
    this.patterns = [
      { test: (href) => href.includes('/policies/'), name: 'policy' },
      { test: (href) => href.includes('instagram.com'), name: 'social' },
      { test: (href) => href.includes('facebook.com'), name: 'social' },
      { test: (href) => href.includes('twitter.com'), name: 'social' },
      { test: (href) => href.includes('x.com'), name: 'social' },
      { test: (href) => href.includes('tiktok.com'), name: 'social' },
      { test: (href) => href.includes('youtube.com'), name: 'social' },
      { test: (href) => href.includes('linkedin.com'), name: 'social' },
      { test: (href) => href.includes('pinterest.com'), name: 'social' },
      { test: (href) => href.includes('tumblr.com'), name: 'social' },
      { test: (href) => href.includes('snapchat.com'), name: 'social' },
      { test: (href) => href.includes('threads.net'), name: 'social' },
      { test: (href) => href.includes('vimeo.com'), name: 'social' },
      { test: (href) => href.includes('bluesky.social'), name: 'social' }
    ];
    this.init();
  }

  init() {
    // Wait for the custom element to be defined
    if (customElements.get('boreal-seo-link')) {
      this.start();
    } else {
      customElements.whenDefined('boreal-seo-link').then(() => {
        this.start();
      });
    }
  }

  start() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.transformLinks());
    } else {
      this.transformLinks();
    }
    
    setTimeout(() => this.transformLinks(), 500);
    this.observeDOMChanges();
  }

  observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      let shouldTransform = false;
      
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches?.('a[href]') || node.querySelectorAll?.('a[href]').length > 0) {
              shouldTransform = true;
            }
          }
        });
      });
      
      if (shouldTransform) this.transformLinks();
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }

  shouldTransform(href, link) {
    // Check if link matches URL patterns
    if (this.patterns.some(pattern => pattern.test(href))) {
      return true;
    }
    
    // Check if link is inside mobile menus
    if (link.closest('.header__drawer--mobile, .menu-list--mobile')) {
      return true;
    }
    
    return false;
  }

  transformLink(link) {
    const href = link.getAttribute('href');
    if (!href || href === '#' || !this.shouldTransform(href, link)) return;
    if (link.hasAttribute('data-transformed')) return;

    try {
      const seoLink = document.createElement('boreal-seo-link');
      seoLink.setAttribute('data-href', href);
      
      // Copy classes
      if (link.className) {
        seoLink.className = link.className;
      }
      
      // Copy relevant attributes
      ['aria-label', 'title', 'data-disabled', 'aria-disabled'].forEach(attr => {
        if (link.hasAttribute(attr)) {
          seoLink.setAttribute(attr, link.getAttribute(attr));
        }
      });
      
      // Determine display mode
      const computedStyle = window.getComputedStyle(link);
      const display = computedStyle.display;
      if (display === 'block' || display === 'flex' || display === 'inline-flex') {
        seoLink.setAttribute('display', display === 'inline-flex' ? 'inline-flex' : display);
      }
      
      // Copy content
      seoLink.innerHTML = link.innerHTML;
      
      // Mark as transformed
      link.setAttribute('data-transformed', 'true');
      
      // Replace
      link.parentNode.replaceChild(seoLink, link);
    } catch (e) {
      // Silent fail
    }
  }

  transformLinks() {
    const links = document.querySelectorAll('a[href]:not([data-transformed])');
    
    links.forEach(link => {
      this.transformLink(link);
    });
  }
}

new BorealSeoLinkAuto();
